import { ModalFactory } from '@vend/vend.ui'
import serviceSaleRefundModal from './service-sale-refund-modal.html'

/**
 * Service class for service refund modals
 *
 * @class ServiceSaleRefundModalService
 */
export class ServiceSaleRefundModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  /**
   * Open the modal responsible for informing user of a refund on a service order
   *
   * @method serviceRefundModal
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public serviceSaleRefundModal() {
    return this.Modal({
      controller: 'serviceSaleRefundModalController',
      controllerAs: '$ctrl',
      template: serviceSaleRefundModal,
    })
  }
}
